import React from "react";
import "./masterBar.scss";

const getRoute = (type, electionNumber = 1) => {
  const host = window.location.hostname.replace("localhost", "lasexta");
  let path = "#";
  if (host.indexOf("lasexta") !== -1) {
    switch (type) {
      case "europeas":
        path = `https://www.lasexta.com/noticias/nacional/elecciones-europeas/resultados/${electionNumber}/espana`;
        break;
      case "municipales":
        path = `https://www.lasexta.com/noticias/nacional/elecciones-municipales/resultados/${electionNumber}/espana`;
        break;
      default:
        path = `https://www.lasexta.com/noticias/nacional/elecciones-autonomicas/resultados/${electionNumber}/espana`;
        break;
    }
  } else if (host.indexOf("antena3") !== -1) {
    switch (type) {
      case "europeas":
        path = `https://www.antena3.com/noticias/elecciones/resultados/elecciones-europeas/2019/${electionNumber}/espana`;
        break;
      case "municipales":
        path = `https://www.antena3.com/noticias/elecciones/resultados/elecciones-municipales/2019/${electionNumber}/espana`;
        break;
      default:
        path = `https://www.antena3.com/noticias/elecciones/resultados/elecciones-autonomicas/2019/${electionNumber}/espana`;
        break;
    }
  }
  if (host.indexOf("ondacero") !== -1) {
    switch (type) {
      case "europeas":
        path = `https://www.ondacero.es/noticias/elecciones-europeas/resultados/2019/${electionNumber}/espana`;
        break;
      case "municipales":
        path = `https://www.ondacero.es/noticias/elecciones-municipales-autonomicas/resultados/2019/${electionNumber}/espana`;
        break;
      default:
        path = `https://www.ondacero.es/noticias/elecciones-municipales-autonomicas/resultados-autonomicas/2019/${electionNumber}/espana`;
        break;
    }
  }

  return path;
};
const changeType = (type, history) => {
  switch (type) {
    case "municipales":
      history.push(`/1/0/2019/1/resultadosmunicipales.html`);

      break;
    case "autonomicas":
      history.push(`/1/0/2019/1/resultadosautonomicos.html`);

      break;
    default:
      //Europeas

      history.push(`/1/0/2019/1/resultadosEuropeas.html`);

      break;
  }
};
const MasterBar = ({ current, reload, history }) => {
  const onClickHandler = type => {
    if (!Boolean(parseInt(reload))) {
      changeType(type, history);
    }
  };
  return (
    <header className="masterBar">
      <h2 className="masterBarTitle">ELECCIONES 26M</h2>
      <nav className="masterBarButtonsContainer">
        <ul className="masterBarButtons">
          <li
            className={`masterBarButton ${current === "autonomicas" &&
              `current`}`}
            onClick={() => onClickHandler("autonomicas")}
          >
            {Boolean(parseInt(reload)) ? (
              <a href={getRoute("autonomicas")}> AUTONÓMICAS </a>
            ) : (
              "AUTONÓMICAS"
            )}
          </li>
          <li
            className={`masterBarButton ${current === "municipales" &&
              `current`}`}
            onClick={() => onClickHandler("municipales")}
          >
            {Boolean(parseInt(reload)) ? (
              <a href={getRoute("municipales")}> MUNICIPALES </a>
            ) : (
              "MUNICIPALES"
            )}
          </li>
          <li
            className={`masterBarButton ${current === "europeas" && `current`}`}
            onClick={() => onClickHandler("europeas")}
          >
            {Boolean(parseInt(reload)) ? (
              <a href={getRoute("europeas")}> EUROPEAS </a>
            ) : (
              "EUROPEAS"
            )}
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default MasterBar;
